<template>
  <div class="line-wrapper">
    <div ref="myLine" class="pie"></div>
  </div>
</template>

<script>
export default {
  name: 'myLine',
  props: {
    lineType: {
      type: String,
      default: '',
    },
    lineData: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      lineProps: [],
    };
  },
  watch: {
    lineData() {
      this.drawLine();
    },
    lineType() {
      this.drawLine();
    },
  },
  mounted: function () {
    this.drawLine();
  },
  methods: {
    formatyAxis(name, name2) {
      if (this.lineType === 'totalCleanArea' || this.lineType === 'totalUsageTime') {
        return [
          {
            type: 'value',
            name: name,
            nameGap: 24,
            minInterval: 1,
            nameTextStyle: {
              color: '#00A0D9',
              lineHeight: 32,
              fontWeight: 'bold',
              align: 'center',
            },
            axisLine: {
              show: true,
              lineStyle: { color: '#F0F0F0' },
            },
            axisLabel: {
              margin: 10,
              fontSize: 10,
              color: '#818181',
            },
            splitLine: {
              show: true,
              lineStyle: { color: '#F0F0F0' },
            },
          },
          {
            type: 'value',
            name: name2,
            nameGap: 24,
            minInterval: 1,
            nameTextStyle: {
              color: '#00A0D9',
              lineHeight: 32,
              fontWeight: 'bold',
              align: 'center',
            },
            axisLine: {
              show: true,
              lineStyle: { color: '#F0F0F0' },
            },
            axisLabel: {
              margin: 10,
              fontSize: 10,
              color: '#818181',
            },
            splitLine: {
              show: true,
              lineStyle: { color: '#F0F0F0' },
            },
          },
        ];
      }
      return {
        type: 'value',
        name: name,
        nameGap: 24,
        nameTextStyle: {
          color: '#00A0D9',
          lineHeight: 32,
          fontWeight: 'bold',
          align: 'center',
        },
        axisLine: {
          show: true,
          lineStyle: { color: '#F0F0F0' },
        },
        axisLabel: {
          margin: 10,
          fontSize: 10,
          color: '#818181',
        },
        splitLine: {
          show: true,
          lineStyle: { color: '#F0F0F0' },
        },
      };
    },
    // 线条样式处理
    formatLineAreaStyle(type, code, color) {
      let lineStyle;
      let areaStyle;
      let itemStyle;
      if (code === 'goalTime' || code === 'goalArea' || code === 'yellowScore' || code === 'redScore') {
        lineStyle = {
          cap: 'butt',
          type: 'solid',
          color: color,
        };
      } else {
        lineStyle = {
          color: color,
          with: 3,
        };
        itemStyle = {
          color: color,
          borderColor: '#ffffff',
          borderWidth: 2,
          borderType: 'solid',
        };
      }
      if (code === 'totalCleanArea' || code === 'totalUsageTime') {
        areaStyle = {
          origin: 'start',
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: 'rgba(0, 160, 217, 0.4)', // 0% 处的颜色
              },
              {
                offset: 1,
                color: 'rgba(0, 160, 217, 0)', // 100% 处的颜色
              },
            ],
            global: false, // 缺省为 false
          },
        };
      }
      const result = { lineStyle, areaStyle, itemStyle };
      return result[type];
    },
    initProps() {
      if (this.lineType === 'cleanScore') {
        this.lineProps = [
          {
            title: this.$t('dashboard_line.de_fen'),
            name: this.$t('dashboard_line.de_fen'),
            code: 'cleanScore',
            color: '#00A0D9',
          },
          {
            name: this.$t('dashboard_line.da_biao_xian'),
            icon: 'rect',
            code: 'yellowScore',
            color: '#FAC04C',
          },
          {
            name: this.$t('dashboard_line.jing_jie_xian'),
            icon: 'rect',
            code: 'redScore',
            color: '#EB5A5A',
          },
        ];
      } else if (this.lineType === 'totalCleanArea') {
        this.lineProps = [
          {
            title: this.$t('dashboard_line.qing_jie_mian_jio', [this.$formatLenUnit()]),
            name: this.$t('dashboard_line.qing_jie_mian_jio', [this.$formatLenUnit()]),
            code: 'totalCleanArea',
            color: '#00A0D9',
          },
          {
            name: this.$t('dashboard_line.mu_biao_zhio', [this.$formatLenUnit()]),
            icon: 'rect',
            code: 'goalArea',
            color: '#FAC04C',
          },
          {
            title: this.$t('dashboard_line.qing_jie_ji_qi_tai'),
            name: this.$t('dashboard_line.qing_jie_ji_qi_tai'),
            code: 'useDeviceCount',
            color: '#51eb32',
          },
        ];
      } else if (this.lineType === 'totalUsageTime') {
        this.lineProps = [
          {
            title: this.$t('dashboard_line.qjscmin'),
            name: this.$t('dashboard_line.qjscmin'),
            code: 'totalUsageTime',
            color: '#00A0D9',
          },
          {
            name: this.$t('dashboard_line.mu_biao_zhimin'),
            icon: 'rect',
            code: 'goalTime',
            color: '#FAC04C',
          },
          {
            title: this.$t('dashboard_line.qing_jie_ji_qi_tai'),
            name: this.$t('dashboard_line.qing_jie_ji_qi_tai'),
            code: 'useDeviceCount',
            color: '#51eb32',
          },
        ];
      } else if (this.lineType === 'useDeviceSite') {
        this.lineProps = [
          {
            title: this.$t('dashboard_line.qu_yu_shu'),
            name: this.$t('dashboard_line.zong_qu_yu'),
            code: 'hasMachineSiteCount',
            color: '#00A0D9',
          },
          {
            name: this.$t('dashboard_line.qing_jie_qu_yu'),
            code: 'useSiteCount',
            color: '#51eb32',
          },
        ];
      }
    },
    drawLine() {
      this.initProps();
      if (this.myChart) {
        this.myChart.dispose();
      }
      // 基于准备好的dom，初始化echarts实例
      this.myChart = this.$echarts.init(this.$refs.myLine);
      // 绘制图表
      this.myChart.setOption(
        {
          tooltip: {
            show: true,
            axiosPointer: {
              type: 'line',
            },
          },
          grid: {
            left: 68,
            right: 68,
          },
          legend: {
            bottom: 0,
            itemGap: 18,
            data: this.lineProps.map(t => ({
              name: t.name,
              icon: t.icon || undefined,
              textStyle: {
                color: '#1A1A1A',
                fontWeight: 'bold',
                fontSize: 12,
              },
              itemStyle: {
                color: t.color || undefined,
              },
            })),
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            axisLine: {
              show: true,
              lineStyle: { color: '#F0F0F0' },
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              margin: 10,
              fontSize: 10,
              color: '#818181',
            },
            data: this.lineData.map(t => t.date), // X轴日期
          },
          yAxis: this.formatyAxis(this.lineProps[0] ? this.lineProps[0].title : '', this.lineProps[2] ? this.lineProps[2].title : ''),
          series: this.lineProps.map(t => ({
            name: t.name,
            type: 'line',
            data: this.lineData.map(f => f[t.code] || undefined),
            showSymbol: !!this.formatLineAreaStyle('itemStyle', t.code, t.color),
            symbolSize: 8,
            symbol: 'circle',
            lineStyle: this.formatLineAreaStyle('lineStyle', t.code, t.color),
            areaStyle: this.formatLineAreaStyle('areaStyle', t.code, t.color),
            itemStyle: this.formatLineAreaStyle('itemStyle', t.code, t.color),
            yAxisIndex: t.code === 'useDeviceCount' ? 1 : 0,
          })),
        },
        { notMerge: true }
      );
    },
  },
};
</script>

<style lang="scss">
.line-wrapper {
  height: 370px;
  position: relative;
  .pie {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10;
  }
}
</style>
